
























































import { AdviceNavigationView, PdfConfiguration } from "@zoovu/runner-web-design-base";
import { Vue, Component, InjectComponent, ComponentConfig, VueComponent } from "@zoovu/runner-browser-api";
import { IconPdfDownload } from "./svgs";

@Component({
  name: "AdviceNavigationView",
  mixins: [AdviceNavigationView],
  components: { IconPdfDownload },
})
export default class AdviceNavigationViewExtended extends Vue {
  @InjectComponent("PdfDownloadButtonView")
  pdfDownloadButtonView: VueComponent;

  @ComponentConfig(PdfConfiguration)
  pdfConfiguration: PdfConfiguration;

  get isPdfButtonVisible(): boolean {
    return this.pdfConfiguration.enabled && this.isResultsPage;
  }
}
